import {AxiosRequestConfig, AxiosResponse} from 'axios'
import {ExceptionError} from '../exception'
import {Request} from '../request'
import {
  IBulkDisciplineCreate,
  IDiscipline,
  IDisciplineCreate,
  IDisciplineUpdate,
} from '../../interface/discipline/discipline'
import {IPageOption} from '../../interface/paging/paging'
import {
  IApiResponse,
  IApiListResponse,
  IBulkTemplateResponse,
} from '../../interface/api-response/api-response'
import {API_PATH} from '../../constants/api-path'

export class GetDisciplineService extends Request {
  async request(options?: IPageOption) {
    try {
      const {data} = await this.client
        .get<IApiListResponse<IDiscipline[]>>(API_PATH.DISCIPLINE, {
          params: options,
        })
        .then((d) => d)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class GetDisciplineFilterService extends Request {
  async request(options?: IPageOption, filter?: any) {
    try {
      for (let key in filter) {
        if (filter.hasOwnProperty(key) && filter[key] === '') {
          filter[key] = undefined
        }
      }
      const {data} = await this.client
        .post<IApiListResponse<IDiscipline[]>>(
          `${API_PATH.DISCIPLINE}/filter`,
          {
            ...filter,
          },
          {
            params: options,
          }
        )
        .then((d) => d)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class CreateDisciplineService extends Request {
  async request(payload: IDisciplineCreate) {
    const {data} = await this.client.post<IDiscipline>(API_PATH.DISCIPLINE, payload)
    try {
      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class UpdateDisciplineService extends Request {
  async request(payload: IDisciplineUpdate) {
    try {
      const {data} = await this.client.patch<IDiscipline>(API_PATH.DISCIPLINE, payload)
      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class DeleteDisciplineService extends Request {
  async request(id: string) {
    try {
      const {data} = await this.client.delete<IApiResponse<any>>(`${API_PATH.DISCIPLINE}/${id}`)
      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class GetDisciplineByPlantService extends Request {
  async request(id: string) {
    try {
      const {data} = await this.client
        .get<IApiResponse<IDiscipline[]>>(`${API_PATH.DISCIPLINE}/get-by-plant-id/${id}`, {
          params: {getOnlyActive: true},
        })
        .then((d) => d)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class GetDisciplineLogService extends Request {
  async request(params: any) {
    try {
      const {data} = await this.client
        .get<IApiResponse<any>>(`${API_PATH.DISCIPLINE}/get-log/${params.id}`, {params})
        .then((d) => d)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}

class GetBulkDisciplineTemplate extends Request {
  async request(companyId: string, plantIds: string[]) {
    try {
      const {data} = await this.client
        .get<IApiResponse<IBulkTemplateResponse>>(`${API_PATH.DISCIPLINE}/bulk-discipline`, {
          params: {companyId, plantIds},
        })
        .then((d) => d.data.data)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}

class CreateBulkDiscipline extends Request {
  async request(payload: IBulkDisciplineCreate) {
    try {
      await this.client.post(`${API_PATH.DISCIPLINE}/bulk-discipline`, payload)
    } catch (error: any) {
      const errMsg: any = !error.response.data?.errors
        ? error.response.data.message
        : `<div style="text-align: left;">${error.response.data.errors
            .map((e) => `<li>${e}</li>`)
            .join('')}</div>`

      throw new ExceptionError({message: errMsg} as any)
    }
  }
}

export class UploadBulkDiscipline extends Request {
  async request(payload: any) {
    try {
      await this.client.post(`${API_PATH.DISCIPLINE}/bulk-discipline/file`, payload)
    } catch (error: any) {
      const errMsg: any = !error.response.data?.errors
        ? error.response.data.message
        : `<div style="text-align: left;">${error.response.data.errors
            .map((e) => `<li>${e}</li>`)
            .join('')}</div>`

      throw new ExceptionError({message: errMsg} as any)
    }
  }
}

export class GetDisciplineHistoryBulkService extends Request {
  async request(params: any) {
    try {
      const {data} = await this.client
        .get<IApiResponse<any>>(`${API_PATH.DISCIPLINE}/bulk-tag/file`, {params})
        .then((d) => d)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class DownloadDisciplineHistoryBulkService extends Request {
  async request(id: string) {
    try {
      const {data} = await this.client
        .get<any>(`${API_PATH.DISCIPLINE}/bulk-tag/file/${id}`, {
          responseType: 'blob', // Important: set response type to blob
        })
        .then((d) => d)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}

export const uploadBulkDiscipline = new UploadBulkDiscipline()
export const createBulkDiscipline = new CreateBulkDiscipline()
export const getBulkDisciplineTemplate = new GetBulkDisciplineTemplate()
